import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/vercel/path0/components/about/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/about/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/about/moduleTeam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/about/stats.tsx");
